/**
 * Minimal structural shape shared by every vendor/pharmacy representation that
 * may carry combined-payment (DrAnsay Pay) availability — `VendorListItem`,
 * `ProductVendorListItem`, `PharmacyPickerItem`, and the cart vendor.
 */
export interface CombinedPaymentVendor {
	combinedPaymentEnabled?: boolean;
}

/**
 * Single source of truth for whether a vendor supports combined payment
 * (DrAnsay Pay). Treats an absent or undefined field as `false` so the badge
 * degrades gracefully on partial API responses (FR-009).
 */
export function isCombinedPaymentEnabled(
	vendor: CombinedPaymentVendor | null | undefined,
): boolean {
	return vendor?.combinedPaymentEnabled === true;
}
